<template>
  <aside class="sidebar">
    <div class="sidebar__container">
      <!-- Logo -->
      <div class="sidebar__logo">
        <img
          src="@/assets/img/logo1.svg"
          class="sidebar__logo-img"
          alt="Wealth Management"
          @click="homePage"
        />
      </div>

      <!-- Navigation -->
      <nav class="sidebar__nav">
        <!-- Main Section -->
        <div class="nav-section">
          <p class="nav-section-label">MAIN</p>
          <SidebarMenu
            title="Overview"
            href="/dashboard/overview"
            :focus="overviewFocus"
          />
        </div>

        <!-- Tools Section -->
        <div class="nav-section">
          <p class="nav-section-label">WEALTH TOOLS</p>
          <SidebarMenu
            v-if="isSubscribedToProducts('PRIVATE_RAISE') && hasPermission('deal:*')"
            title="Private Raise"
            href="/dashboard/private-raise"
            :focus="privateFocus || $route.path.includes('private-raise')"
          />
          <SidebarMenu
            title="Employee Benefits"
            href="/dashboard/employee-benefits"
            v-if="isSubscribedToProducts('ESOP') && hasPermission('deal:*')"
            :focus="employeeFocus || $route.path.includes('employee-benefits')"
          />
          <SidebarMenu
            v-if="
              (isSubscribedToProducts('PUBLIC_RAISE') ||
              isSubscribedToProducts('PUBLIC_RAISE_REVIEW') ||
              isSubscribedToProducts('PUBLIC_RAISE_PENDING') ||
              isSubscribedToProducts('PUBLIC_RAISE_REJECTED')) && hasPermission('deal:*')
            "
            title="Public Raise"
            href="/dashboard/public-raise"
            :focus="publicFocus || $route.path.includes('public-raise')"
          />
          <SidebarMenu
            v-if="isSubscribedToProducts('INVEST') && hasPermission('invest:*')"
            title="Treasury"
            :children="treasuryPages"
            :focus="
              investFocus ||
              $route.path.includes('invest') ||
              $route.path.includes('trade')
            "
          />
          <SidebarMenu
            v-if="
              (isSubscribedToProducts('API_KEY') ||
              this.organisationDetails?.type === 'API KEY') &&
              hasPermission('api:*')
            "
            title="API Integration"
            href="/dashboard/api-client"
            :focus="apiFocus || $route.path.includes('api-client')"
          />
          <SidebarMenu
            v-if="
              (isSubscribedToProducts('CREDIT') ||
              this.organisationDetails?.type === 'Credit') &&
              hasPermission('credit:*')
            "
            title="Credit Provider"
            href="/dashboard/credit-provider"
            :focus="apiFocus || $route.path.includes('credit-provider')"
          />
        </div>

        <!-- Management Section -->
        <div class="nav-section">
          <p class="nav-section-label">MANAGEMENT</p>
          <SidebarMenu
            v-if="hasPermission('team:*')"
            title="Teams"
            href="/dashboard/teams"
            :focus="teamsFocus || $route.path.includes('/dashboard/teams')"
          />
          <SidebarMenu
            title="Wallet"
            href="/dashboard/wallet"
            :focus="walletFocus"
            v-if="hasPermission('wallet:*') && hasPermission('bank:*')"
          />
          <SidebarMenu
            title="Account"
            href="/dashboard/account"
            :focus="accountFocus"
          />
        </div>
      </nav>

      <!-- User Profile Footer -->
      <div class="sidebar__footer">
        <div class="user-profile">
          <div class="user-avatar">
            {{ userInitials }}
          </div>
          <div class="user-info">
            <p class="user-name">{{ organisationDetails?.name || 'Business' }}</p>
            <p class="user-role">Administrator</p>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<!-- refactor focus/active state logic -->
<script>
import SidebarMenu from "@/components/navigation/SidebarMenu.vue";
import { mapActions, mapGetters } from "vuex";
import { getItem } from "@/utils/storage";

export default {
  name: "Sidebar",

  components: { SidebarMenu },

  data() {
    return {
      // Treasury is one product with three views. The header only toggles; Overview is an
      // explicit child so there is never a question of what clicking the parent does.
      treasuryPages: [
        { title: "Overview", href: "/dashboard/invest" },
        { title: "Opportunities", href: "/dashboard/invest/opportunities" },
        { title: "My Investments", href: "/dashboard/invest/investments" },
        { title: "Exchange", href: "/dashboard/invest/exchange" },
      ],
      overviewFocus: false,
      dealsFocus: false,
      employeeFocus: false,
      transactionsFocus: false,
      walletFocus: false,
      apiFocus: false,
      privateFocus: false,
      publicFocus: false,
      investFocus: false,
      publicFocus: false,
      accountFocus: false,
      creditFocus: false,
      teamsFocus: false,
      userPermissions: [],
    };
  },

  created() {
    this.setFocus(this.$route.name);

    this.loadUserPermissions();
  },
  mounted() {
    this.checkUserProducts();
  },
  computed: {
    ...mapGetters("organisationModule", ["products", "organisationDetails"]),
    userInitials() {
      const name = this.organisationDetails?.name || 'B';
      return name.substring(0, 2).toUpperCase();
    },
  },

  methods: {
    ...mapActions(["logout"]),
    homePage() {
      window.location.reload();
    },
    isSubscribedToProducts(product) {
      // API_KEY | PRIVATE_RAISE | INVEST | ESOP | PUBLIC_RAISE / CREDIT
      let subProducts = this.products?.split(" ");
      let sub = subProducts?.indexOf(product);
      if (sub !== -1) return product;
    },

    checkUserProducts() {
      if (
        (this.organisationDetails?.products.includes("RAISE") &&
          !this.organisationDetails?.products.includes("PRIVATE_RAISE") &&
          !this.organisationDetails?.products.includes("PUBLIC_RAISE")) ||
        this.organisationDetails?.products.includes("DEALROOM")
      ) {
        this.logout();
      }
    },

    loadUserPermissions() {
      const teamMember = getItem("team_member");

      if (teamMember) {
        const parsedPermissions = teamMember.groups?.[0]?.permissions?.[0] || [];

        console.log(parsedPermissions, "parsed");
        try {
          if (parsedPermissions) {
            if (parsedPermissions && parsedPermissions?.actions) {
              this.userPermissions = parsedPermissions?.actions;
            }
          }
        } catch (error) {
          console.error("Error parsing permissions:", error);
        }
      }
    },

    hasPermission(permission) {
      if (!this.userPermissions || this.userPermissions.length === 0) {
        return true;
      }

      if (permission.endsWith("*")) {
        const prefix = permission.slice(0, -1);

        return this.userPermissions.some((p) => p.startsWith(prefix));
      }

      return this.userPermissions.includes(permission);
    },

    setFocus(route) {
      this.overviewFocus = false;
      this.dealsFocus = false;
      this.transactionsFocus = false;
      this.walletFocus = false;
      this.apiFocus = false;
      this.accountFocus = false;
      this.employeeFocus = false;
      this.privateFocus = false;
      this.publicFocus = false;
      this.investFocus = false;
      this.creditFocus = false;
      this.teamsFocus = false;
      switch (route) {
        case "OverviewDetails":
          this.overviewFocus = true;
          break;
        case "Features":
          this.overviewFocus = true;
          break;
        case "Deals":
          this.dealsFocus = true;
          break;
        case "DealInfo":
          this.dealsFocus = true;
        case "PrivateRaise":
          this.dealsFocus = true;
          break;
        case "PublicRaise":
          this.publicFocus = true;
          break;
        case "EmployeeBenefits":
          this.employeeFocus = true;
          break;
        case "CreateDeal":
          this.dealsFocus = true;
          break;
        case "CreateAsset":
          this.dealsFocus = true;
          break;
        case "Transactions":
          this.transactionsFocus = true;
          break;
        case "Wallet":
          this.walletFocus = true;
          break;
        case "ApiClient":
          this.membersFocus = true;
          break;
        case "Account":
          this.accountFocus = true;
          break;
        case "ResetPassword":
          this.accountFocus = true;
          break;
        case "CreditProvider":
          this.creditFocus = true;
          break;
        case "Teams":
          this.teamsFocus = true;
          break;

        default:
          break;
      }
    },
  },

  watch: {
    $route(to, from) {
      if (to !== from) {
        this.setFocus(this.$route.name);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 260px;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  position: fixed;
  height: 100vh;
  display: none;
  z-index: 50;

  @media (min-width: 1280px) {
    display: block;
  }

  &__container {
    width: 260px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
    border-bottom: 1px solid #e2e8f0;
  }

  &__logo-img {
    cursor: pointer;
    max-height: 32px;
  }

  &__nav {
    flex: 1;
    padding: 8px 0;
    overflow-y: auto;
  }

  &__footer {
    padding: 16px;
    border-top: 1px solid #e2e8f0;
    margin-top: auto;
  }
}

.nav-section {
  margin-bottom: 24px;
}

.nav-section-label {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  letter-spacing: 0.5px;
  padding: 0 16px;
  margin-bottom: 8px;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f1f5f9;
  }
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
}

.user-info {
  overflow: hidden;
}

.user-name {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 12px;
  color: #94a3b8;
}
</style>
